import React, { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AlertBanner } from '@spark';

/**
 * Info banner shown when no commercial model providers are selectable,
 * linking to the provider keys tab in Account Settings.
 *
 * ``classificationOnlyConfigured``: the configured provider(s) are
 * classification-only decision models (TypeSafe AI) hidden on this task
 * type — the banner then explains that instead of the generic "no
 * providers" text.
 */
const NoProvidersAlert = ({ classificationOnlyConfigured = false }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const goToModelProvidersSettings = useCallback(() => {
        navigate('/settings?tab=providers', {
            state: { from: `${location.pathname}${location.search}${location.hash}` },
        });
    }, [navigate, location.pathname, location.search, location.hash]);

    return (
        <AlertBanner
            feedback="info"
            showButton={false}
            showCloseButton={false}
            text={
                <span className="fs-unmask" style={{ fontSize: 13 }}>
                    {classificationOnlyConfigured
                        ? 'TypeSafe AI supports classification tasks only. To enable Model selection, add an API key or cloud credentials in '
                        : 'To enable Model selection, add an API key or cloud credentials in '}
                    <a
                        onClick={(e) => {
                            e.preventDefault();
                            goToModelProvidersSettings();
                        }}
                        style={{
                            color: 'var(--semantic-button-link-content-on-surface-default)',
                            cursor: 'pointer',
                        }}
                    >
                        Account Settings
                    </a>
                    .
                </span>
            }
        />
    );
};

export default NoProvidersAlert;
